import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { Button } from './ui/button';

export const PartnerTeaserSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-white border border-gray-200 rounded-2xl p-8 lg:p-12">
          {/* Titel */}
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
            Partnerprogramm für Werkstätten & Betriebe
          </h2>
          
          {/* Kurztext */}
          <p className="text-lg text-gray-700 mb-8 leading-relaxed">
            Sie vermitteln Fälle, wir übernehmen die Abwicklung. Sie erhalten einen Portal-Zugang und können Unfalldaten und Fotos strukturiert einreichen.
          </p>
          
          {/* 3 Bulletpoints */}
          <div className="space-y-4 mb-8">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-brand-green/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <Check className="w-4 h-4 text-brand-green" />
              </div>
              <p className="text-gray-700">
                Abo: ab 29,99 € inkl. MwSt. pro Monat
              </p>
            </div>
            
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-brand-green/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <Check className="w-4 h-4 text-brand-green" />
              </div>
              <p className="text-gray-700">
                Vermittlungsprovision: 30% Start, 40% ab 10 Fällen/Monat, 50% ab 20 Fällen/Monat (jeweils 3 Monate stabil)
              </p>
            </div>
            
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-brand-green/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <Check className="w-4 h-4 text-brand-green" />
              </div>
              <p className="text-gray-700">
                Upload-Fallstrecke mit Pflichtbildern, Dokumenten und klarer Schritt-für-Schritt-Führung
              </p>
            </div>
          </div>
          
          {/* CTA */}
          <div>
            <a href="/partner/abo">
              <Button className="bg-brand-green hover:bg-brand-green-dark text-white font-semibold px-8 py-4 rounded-xl">
                Abo starten
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
